import _ from 'underscore';
import jsdataCampaign from '@bingads-webui-component-legacy/js-data-campaign/index';

const odataOptions = {
  path: 'AdInsight/V2/',
  url: '/Customers(:advertisercustomer_id)/Accounts(:account_id)/Default.DSACategoryList',
};

export const loadCategoryList = (domainName, languageCode, category, keyword, orderby, skip) => jsdataCampaign.CategoryTarget.findAll({
  query: {
    $top: 100,
    domainName,
    languageCode: languageCode || 'en',
    ...(category ? { category } : {}),
    ...(orderby ? { $orderby: orderby } : {}),
    ...(skip ? { $skip: skip } : {}),
  },
  ...(keyword ? {
    where: {
      CategoryName: {
        $contains: keyword,
      },
    },
  } : {}),
}, _.defaults({ cacheResponse: false }, odataOptions));

export const loadCategoryNameList = (domainName, languageCode) => jsdataCampaign.CategoryTarget.findAll({
  query: {
    $select: 'CategoryName',
    $top: 20000,
    domainName,
    languageCode: languageCode || 'en',
  },
}, _.defaults({ cacheResponse: false }, odataOptions));
